import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client";

const GET_RELATED_MEMBER = gql`
  query getMember($selectedAccountId: ID, $id: ID!) {
    account(sourceAccountId: $selectedAccountId) {
      member(id: $id) {
        id
        firstName
        lastName
        photo
        state
        isAsleep

        relationship {
          poolType
        }
      }
    }
  }
`;

export const useGetRelatedMember = ({
  assignedMemberId,
  selectedAccountId
}) => {
  const { data, loading, error } = useQuery(GET_RELATED_MEMBER, {
    skip: !assignedMemberId,
    variables: {
      id: assignedMemberId,
      selectedAccountId
    },
    fetchPolicy: "cache-first",
    onError: error => {
      throw error;
    }
  });

  return {
    member: data?.account?.member,
    loading,
    error
  };
};
